import { initAll } from "govuk-frontend";
import "./modules/module-init";

import "./modules/timeoutPage";
import "./modules/cookieBanner";
import "./modules/uploadEvidence";
import "./modules/help-images";

document.addEventListener("DOMContentLoaded", () => {
  initAll();
});
